export class GcpDiskResource {
    'diskId';
    'diskName';
    'diskType';
    'sizeGb';
    'region';
    'zone';
    'status';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "diskId",
            "baseName": "diskId",
            "type": "string",
            "format": ""
        },
        {
            "name": "diskName",
            "baseName": "diskName",
            "type": "string",
            "format": ""
        },
        {
            "name": "diskType",
            "baseName": "diskType",
            "type": "GcpDiskResourceDiskTypeEnum",
            "format": ""
        },
        {
            "name": "sizeGb",
            "baseName": "sizeGb",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "zone",
            "baseName": "zone",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "GcpDiskResourceStatusEnum",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpDiskResource.attributeTypeMap;
    }
    constructor() {
    }
}
export var GcpDiskResourceDiskTypeEnum;
(function (GcpDiskResourceDiskTypeEnum) {
    GcpDiskResourceDiskTypeEnum["PdStandard"] = "pd-standard";
    GcpDiskResourceDiskTypeEnum["PdBalanced"] = "pd-balanced";
    GcpDiskResourceDiskTypeEnum["PdSsd"] = "pd-ssd";
    GcpDiskResourceDiskTypeEnum["PdExtreme"] = "pd-extreme";
    GcpDiskResourceDiskTypeEnum["HyperdiskBalanced"] = "hyperdisk-balanced";
    GcpDiskResourceDiskTypeEnum["HyperdiskBalancedHighAvailability"] = "hyperdisk-balanced-high-availability";
    GcpDiskResourceDiskTypeEnum["HyperdiskExtreme"] = "hyperdisk-extreme";
    GcpDiskResourceDiskTypeEnum["HyperdiskMl"] = "hyperdisk-ml";
    GcpDiskResourceDiskTypeEnum["HyperdiskThroughput"] = "hyperdisk-throughput";
})(GcpDiskResourceDiskTypeEnum || (GcpDiskResourceDiskTypeEnum = {}));
export var GcpDiskResourceStatusEnum;
(function (GcpDiskResourceStatusEnum) {
    GcpDiskResourceStatusEnum["Creating"] = "CREATING";
    GcpDiskResourceStatusEnum["Restoring"] = "RESTORING";
    GcpDiskResourceStatusEnum["Failed"] = "FAILED";
    GcpDiskResourceStatusEnum["Ready"] = "READY";
    GcpDiskResourceStatusEnum["Deleting"] = "DELETING";
})(GcpDiskResourceStatusEnum || (GcpDiskResourceStatusEnum = {}));
